export default {
  route: {
    profile: '首页',
    other: '其他',
    demo: '测试',
    demoIndex: '测试',
    AdminLog: '日志',
    permission: '权限',
    permissionMark: '权限资源',
    permissionRole: '角色列表',
    permissionAdmin: '管理员列表',
    permissionAllAdmin: '平台管理员',
    account: '备用金（现金）',
    account_group: '分组',
    accounts: '备用金（现金）',
    operation: '店铺运营记录',
    operation_group: '分组',
    operations: '店铺运营记录',
    original: '原料（中央厨房）',
    original_category: '原料分类',
    original_originals: '原料库',
    original_change_price: '原料成本',
    original_store_stock: '门店库存',
    config: '配置',
    config_unit: '计量单位',
    purchase: '采购（集团管理)',
    purchase_index: '采购单',
    config_supplier: '供货商管理',
    config_channel: '售卖渠道',
    transfer: '门店调货',
    store_inventory: '门店库存',
    config_store: '门店管理',
    goodsAttr: '菜品属性',
    goodsAttrNew: '新品属性',
    goodsCategory: '菜品分类',
    goodsCategoryNew: '新品分类',
    goods: '菜品（培训中心）',
    goodsList: '菜品库',
    goodsListNew: '新品库',
    salary: '人力',
    salary_index: '职工待遇规划',
    goods_new: '研发中心',
    supply_index: '供应链管理',
    config_system: '系统配置',
    verson: '测试',
    verson_index: '测试',
    supply: '供应链（集团管理)',
    medicine: '药品',
    medicineIndex: '药品管理',
    manage: '管理',
    manageSchedule: '排班管理',
    basePointStockAdjust: '库存调平',
    salary_worker_report: '工作汇报',
    salary_worker_fix: '报修',
    salary_worker_sale: '营业额汇报',
    salary_worker_study_file: '员工学习',
    salary_worker_agreement: '劳动合同',
    in: '进货',
    inIndex: '进货管理',
    salary_sheet_finance: '财务',
    config_courier_company: '快递公司',
    display: '展示',
    displaySale: '实收金额',
    tools: '工具',
    basePoint: ' 扣库（菜品）',
    displayProfit: '剩余利润',
    basePointIndex: '基点',
    basePointOrder: '订单扣库',
    basePointStockAlert: '库存预警',
    salary_sheet: '工资条',
    displayPrepare: '开店准备',
    salary_sheet_labor: '劳动合同',
    userRegisterApply: '注册申请',
    displayCal: '盈利计算器',
    join_owner: '加盟商',
    config_verson1_bank: '门店管理',
    config_goods_brand: '品牌管理',
    config_takeout_platform: '平台管理',
    config_common_goods_category: '商品库分类',
    config_common_goods: '商品库',
    map: '地图'
  },
  toast: {
    switchLangSuccess: '切换语言成功'
  },
  tagsView: {
    refresh: '刷新',
    closeRight: '关闭右侧',
    closeOther: '关闭其他'
  },
  theme: {
    themeColorChange: '主题色更换',
    themeChange: '主题更换'
  },
  universal: {
    title: '提示',
    confirm: '确定',
    cancel: '取消'
  },
  navBar: {
    themeChange: '主题修改',
    headerSearch: '页面搜索',
    screenfull: '全屏替换',
    lang: '国际化',
    guide: '功能引导',
    home: '首页',
    course: '课程主页',
    logout: '退出登录'
  },
  guide: {
    close: '关闭',
    next: '下一个',
    prev: '上一个',
    guideTitle: '引导',
    guideDesc: '打开引导功能',
    hamburgerTitle: '汉堡按钮',
    hamburgerDesc: '打开和关闭左侧菜单',
    breadcrumbTitle: '面包屑',
    breadcrumbDesc: '指示当前页面位置',
    searchTitle: '搜索',
    searchDesc: '页面链接搜索',
    fullTitle: '全屏',
    fullDesc: '页面显示切换',
    themeTitle: '主题',
    themeDesc: '更换项目主题',
    langTitle: '国际化',
    langDesc: '语言切换',
    tagTitle: '标签',
    tagDesc: '已打开页面标签',
    sidebarTitle: '菜单',
    sidebarDesc: '项目功能菜单'
  }
}
